import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Drawer } from '@mui/material';
var containerStyles = {
    width: '65vw',
};
var PanelWrapper = function (_a) {
    var children = _a.children, open = _a.open, onClose = _a.onClose;
    return (_jsx(Drawer, { anchor: 'right', open: open, onClose: onClose, children: _jsx(Box, { style: containerStyles, children: children }) }));
};
export default PanelWrapper;
